/**
 * A/B switch for the dock tile's outline treatment.
 *
 * Two options, both real — this is not a mock in the lab, it changes the strip
 * you are actually playing on:
 *
 *   'ring'  the tile's existing turn ring is tinted to the outcome's colour and
 *           held STATIC — the same element the shot clock colours, so the tile
 *           never grows a second contour competing with the first. (default,
 *           picked on the strip 8/27)
 *   'none'  the stamp and the orbs carry it. No outline at all.
 *
 * Deliberately not a pulsing halo: that was a third outline nobody asked for,
 * it did not match the countdown ring it sat next to, and its glow bled below
 * the tile where it read as a stray underline.
 */

export type DockOutline = 'none' | 'ring';

const KEY = 'hijack_dock_outline';
const listeners = new Set<() => void>();

export const getDockOutline = (): DockOutline => {
  try {
    return localStorage.getItem(KEY) === 'none' ? 'none' : 'ring';
  } catch {
    return 'ring';
  }
};

export const setDockOutline = (v: DockOutline): void => {
  try {
    localStorage.setItem(KEY, v);
  } catch {
    // Private mode — the toggle just will not persist.
  }
  listeners.forEach((l) => l());
};

export const subscribeDockOutline = (l: () => void): (() => void) => {
  listeners.add(l);
  return () => listeners.delete(l);
};
